import type { Tone } from "@/types/nav";

export interface ToneStyle {
  gradient: string;
  softBg: string;
  softText: string;
  softBorder: string;
  solidBg: string;
  hoverText: string;
}

export const toneStyles: Record<Tone, ToneStyle> = {
  primary: {
    gradient: "from-primary-500 to-primary-700",
    softBg: "bg-primary-100",
    softText: "text-primary-700",
    softBorder: "border-primary-200",
    solidBg: "bg-primary-500",
    hoverText: "group-hover:text-primary-600",
  },
  accent: {
    gradient: "from-accent-500 to-accent-600",
    softBg: "bg-accent-100",
    softText: "text-accent-700",
    softBorder: "border-accent-200",
    solidBg: "bg-accent-500",
    hoverText: "group-hover:text-accent-600",
  },
  secondary: {
    gradient: "from-secondary-500 to-secondary-600",
    softBg: "bg-secondary-100",
    softText: "text-secondary-700",
    softBorder: "border-secondary-200",
    solidBg: "bg-secondary-500",
    hoverText: "group-hover:text-secondary-600",
  },
};

export function getTone(tone: Tone): ToneStyle {
  return toneStyles[tone] ?? toneStyles.primary;
}

// icon bubble gradients cycled by index for visual variety (literal classes only)
export const bubbleGradients: string[] = [
  "from-primary-500 to-primary-700",
  "from-accent-500 to-accent-600",
  "from-secondary-500 to-secondary-600",
  "from-primary-600 to-primary-800",
  "from-accent-600 to-accent-700",
  "from-secondary-600 to-secondary-700",
];

export function gradientAt(index: number): string {
  return bubbleGradients[index % bubbleGradients.length];
}